import {credentialData} from "../data/Credentials"

function Credentials() {
  return (
    <section className="mb-5">
      <div className="container">
        <p className="noto-serif-jp text-center fw-bold h3 pt-3">Backed by Trusted Credentials</p>
        <p className="text-center mb-4">As a certified QuickBooks specialist, I’m committed to accuracy, reliability, and helping your business thrive.</p>
        <div className="row">
          {credentialData.map((cert, index) => (
          <div key={index} className="col-6 col-md-3">
            <picture>
              {cert.source.map((img, inx) => (
                <source key={inx} srcSet={img.srcSet} type={img.type} />
              ))}
              <img src={cert.fallbackSrc} alt={cert.alt} className="w-100"/>
            </picture>
          </div>
          ))}
        </div>
      </div>
    </section>
  );
}

export default Credentials;
